import React from 'react';
import { translate } from 'react-i18next';

import NotificationChoices from 'components/account/NotificationChoices.js';
import UIStatusDialog from 'components/UIStatusDialog.js';

class AccountCalloutPreferences extends React.Component {
  constructor(props) {
    super(props);
    this.handlePreferenceSave = this.handlePreferenceSave.bind(this);
    this.handleSettingChange = this.handleSettingChange.bind(this);
    this.toggleSetting = this.toggleSetting.bind(this);
    this.state = {
      settings: {},
      validationWarnings: '',
    };
  }

  handlePreferenceSave(e) {
    e.preventDefault();
    MakeShiftEmployeeDispatcher.dispatch({
      actionType: appConstants.ActionTypes.UPDATE_SETTINGS,
      postData: this.state.settings.preferences,
    });
  }

  toggleSetting(setting, value) {
    const settings = _.clone(this.state.settings);
    const key = settings.hasOwnProperty(setting);
    if (key) {
      settings[setting] = value;
    }
    this.setState({
      settings,
    });
  }

  handleSettingChange(setting, value) {
    const settings = _.clone(this.state.settings);
    const key = settings.preferences.hasOwnProperty(setting);
    if (key) {
      settings.preferences[setting] = [value];
    }
    this.setState({
      settings,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      settings: nextProps.settings,
      user_id: nextProps.user.id,
    });
  }

  render() {
    const { settings } = this.props;

    let shiftOfferNotifications = this.props.settings.shift_offers;
    if (!_.isUndefined(this.state.settings.shift_offers)) {
      shiftOfferNotifications = this.state.settings.shift_offers;
    }

    let offersAccetedNotifications = this.props.settings.offer_accepted;
    if (!_.isUndefined(this.state.settings.offer_accepted)) {
      offersAccetedNotifications = this.state.settings.offer_accepted;
    }

    let offersDeclinedNotifications = this.props.settings.offer_declined;
    if (!_.isUndefined(this.state.settings.offer_declined)) {
      offersDeclinedNotifications = this.state.settings.offer_declined;
    }

    const statusDialogs = [];
    for (let i = 0; i < this.props.statuses.length; i++) {
      statusDialogs.push(
        <UIStatusDialog
          status={this.props.statuses[i]}
          key={this.props.statuses[i].key}
          closeDialog={this.props.closeStatusDialog}
        />,
      );
    }

    const validOptions = ['push', 'sms', 'email', 'phone'];

    if (!this.props.settings.preferences) {
      return false;
    }

    return (
      <div className={this.props.activeState}>
        <form
          className="account-callout-preferences"
          onSubmit={this.handlePreferenceSave.bind(this)}
        >
          <fieldset className="account-preferences">
            <legend>
              <h1>{this.props.t('AccountCalloutPreferences.notification_preferences')}</h1>
            </legend>
            <p>{this.props.t('AccountCalloutPreferences.receive_notifications_when')}:</p>
            <NotificationChoices
              label={this.props.t('AccountCalloutPreferences.new_shift_available')}
              contactInfoCallbackHandler={this.props.onClickHandler}
              notificationType="shift_offers"
              validOptions={validOptions}
              user={this.props.user}
              currentPreference={this.props.settings.preferences.shift_offers_methods}
              settings={settings}
              enabled={shiftOfferNotifications}
              toggleSetting={this.toggleSetting.bind(this)}
              handleSettingChange={this.handleSettingChange.bind(this)}
            />
            <NotificationChoices
              label={this.props.t('AccountCalloutPreferences.shift_requested_is_assigned')}
              contactInfoCallbackHandler={this.props.onClickHandler}
              notificationType="offer_accepted"
              validOptions={validOptions}
              user={this.props.user}
              currentPreference={this.props.settings.preferences.offer_accepted_methods}
              settings={settings}
              enabled={offersAccetedNotifications}
              toggleSetting={this.toggleSetting.bind(this)}
              handleSettingChange={this.handleSettingChange.bind(this)}
            />
            <NotificationChoices
              label={this.props.t('AccountCalloutPreferences.shift_requested_is_declined')}
              contactInfoCallbackHandler={this.props.onClickHandler}
              notificationType="offer_declined"
              validOptions={validOptions}
              user={this.props.user}
              currentPreference={this.props.settings.preferences.offer_declined_methods}
              settings={settings}
              enabled={offersDeclinedNotifications}
              toggleSetting={this.toggleSetting.bind(this)}
              handleSettingChange={this.handleSettingChange.bind(this)}
            />
            <input 
              name="login" 
              type="submit" 
              value={this.props.t('AccountCalloutPreferences.save_changes')} 
            />
          </fieldset>
          {statusDialogs}
        </form>
      </div>
    );
  }
}

export default translate()(AccountCalloutPreferences);
